import React, { useState, useEffect } from 'react'
import moment from 'moment'
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { getDashboardDataForAMuagentByDate, getDealerWisAgentPerformanceByDate, getLeadageingPerformanceForAmuAgent,getAvgTatGraphforAmuAgent } from './ActionCreator';
import Loader from '../../../../presentationals/Loader/Loader.component'
import { CheckFunction } from '../../../../../layouts/MainTenantconfig';
export default function DashboardAmuAgentnew({ communityId, handlePage }) {
    const tenant = CheckFunction()
    console.log("communityId", communityId)
    const [payload, setPayload] = useState({
        fromDate: moment(new Date).format("YYYY-MM-DD"),
        toDate: moment(new Date).format("YYYY-MM-DD"),
    })
    const [loader, setLoader] = useState(false)
    const [ApiData, setApiData] = useState({})
    const [dealerAgentPerformance, setdealerAgentPerformance] = useState([])
    const [agentPerformance, setAgentPerformance] = useState([])
    const [ageingData,setageingData]=useState("week")
    const [agentPerformanceData,setagentPerformanceData] =useState("assigned")
    const [avgTatData,setavgTatData] =useState("week")
    const [avgTatGraphData,setavgTatGraphData] =useState([])


    const handleChange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const handleApply = () => {
        getDashboardDataForAMuagentByDateFn(communityId, payload)
        getDealerWisAgentPerformanceByDateFn(communityId, payload,agentPerformanceData)
        getLeadageingPerformanceForAmuAgentFn(communityId,ageingData,payload)
        getAvgTatGraphforAmuAgentFn(communityId,ageingData,payload)
    }


    useEffect(() => {
        getDashboardDataForAMuagentByDateFn(communityId, payload)
        getDealerWisAgentPerformanceByDateFn(communityId, payload,agentPerformanceData)
        getLeadageingPerformanceForAmuAgentFn(communityId,ageingData,payload)
        getAvgTatGraphforAmuAgentFn(communityId,ageingData,payload)
    }, [])

    const getDashboardDataForAMuagentByDateFn = (commId, payload) => {
        setLoader(true)
        const startDate = moment(payload?.fromDate).format("DD-MM-YYYY")
        const endDate = moment(payload?.toDate).format("DD-MM-YYYY")
        const data = {
            communityId: commId,
            sDate: startDate,
            eDate: endDate,
        }
        getDashboardDataForAMuagentByDate(data, callback => {
            setLoader(false)
            console.log("call", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setApiData(callback?.data)
            } else {
                setApiData({})
            }
        })
    }

    const getDealerWisAgentPerformanceByDateFn = (commId, payload,type) => {
        const startDate = moment(payload?.fromDate).format("DD-MM-YYYY")
        const endDate = moment(payload?.toDate).format("DD-MM-YYYY")
        const data = {
            communityId: commId,
            sDate: startDate,
            eDate: endDate,
            filterType:type
        }
        setLoader(true)
        getDealerWisAgentPerformanceByDate(data, callback => {
            setLoader(false)
            console.log("call", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setdealerAgentPerformance(callback?.data)
            } else {
                setdealerAgentPerformance([])
            }
        })
    }
    const getLeadageingPerformanceForAmuAgentFn = (commId,type,payload) => {
        const startDate = moment(payload?.fromDate).format("DD-MM-YYYY")
        const endDate = moment(payload?.toDate).format("DD-MM-YYYY")
       
        const data = {
            communityId: commId,
            filterType: type,
            sDate: startDate,
            eDate: endDate,
        }
        setLoader(true)
        getLeadageingPerformanceForAmuAgent(data, callback => {
            setLoader(false)
            console.log("call", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setAgentPerformance(callback?.data)
            } else {
                setAgentPerformance([])
            }
        })
    }

    const getAvgTatGraphforAmuAgentFn = (commId,type,payload) => {
        const startDate = moment(payload?.fromDate).format("DD-MM-YYYY")
        const endDate = moment(payload?.toDate).format("DD-MM-YYYY")
       
        const data = {
            communityId: commId,
            filterType: type,
            sDate: startDate,
            eDate: endDate,
        }
        setLoader(true)
        getAvgTatGraphforAmuAgent(data, callback => {
            setLoader(false)
            console.log("call", callback)
            if (callback && callback?.message == "success" && callback?.status == 200) {
                setavgTatGraphData(callback?.data)
            } else {
                setavgTatGraphData([])
            }
        })
    }

    const handleAgeing =(e)=>{
        setageingData(e.target.value)
        getLeadageingPerformanceForAmuAgentFn(communityId,e.target.value)
    }
    const handleTat =(e)=>{
        setavgTatData(e.target.value)
        getAvgTatGraphforAmuAgentFn(communityId,e.target.value,payload)
    }
    const handleAgentPerformance =(e)=>{
        setagentPerformanceData(e.target.value)
        getDealerWisAgentPerformanceByDateFn(communityId,payload,e.target.value)
    }

    return (
        <>
        {
            loader ?
            <Loader />
:''        }

            <div className="row">
                <div className="col-sm-2 col-xs-6">
                    <label htmlFor="">Start Date</label>
                    <input type='date' value={payload?.fromDate} className='form-control' onChange={(e) => handleChange(e, "fromDate")} />
                </div>
                <div className="col-sm-2 col-xs-6">
                    <label htmlFor="">End Date</label>
                    <input type='date' value={payload?.toDate} className='form-control' onChange={(e) => handleChange(e, "toDate")} />
                </div>
                <div className="col-sm-2 col-xs-6">
                    <button className='btn btn-primary' onClick={() => handleApply()} style={{ marginTop: '22px',padding:'10px' }}>Filter</button>
                </div>
            </div>

            <div className="row" style={{ marginTop: '30px' }}>
                <div className="col-sm-6 col-xs-12">
                    <div className="row">
                        <div className="col-sm-6 col-xs-6">
                            <div style={tabsStyle}>
                                <div className="circleIcons" style={{ ...circleStyle, background: '#579a1d33' }}>
                                    <GroupIcon style={{ fontSize: '24px', color: '#579A1D' }} />
                                </div>
                                <div className="text" style={{ marginLeft: '10px' }}>
                                    <h2 style={{ margin: '10px 0' }}><b>{ApiData?.communityStats?.assigned || "0"}</b></h2>
                                    <h4>Total Leads Assigned</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-6">
                            <div style={tabsStyle}>
                                <div className="circleIcons" style={{ ...circleStyle, background: '#fa8d2033' }}>
                                    <PersonIcon style={{ fontSize: '24px', color: '#FA8D20' }} />
                                </div>
                                <div className="text" style={{ marginLeft: '10px' }}>
                                    <h2 style={{ margin: '10px 0' }}><b>{ApiData?.communityStats?.contacted || "0"}</b></h2>
                                    <h4>Leads Contacted</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: '20px' }}>
                        <div className="col-sm-6 col-xs-6">
                            <div style={tabsStyle}>
                                <div className="circleIcons" style={{ ...circleStyle, background: '#ee439e33' }}>
                                    <PersonIcon style={{ fontSize: '24px', color: '#EE439E' }} />
                                </div>
                                <div className="text" style={{ marginLeft: '10px' }}>
                                    <h2 style={{ margin: '10px 0' }}><b>{ApiData?.communityStats?.converted || "0"}</b></h2>
                                    <h4>Leads Converted</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-6">
                            <div style={tabsStyle}>
                                <div className="circleIcons" style={{ ...circleStyle, background: '#fdd44033' }}>
                                    <LeaderboardIcon style={{ fontSize: '24px', color: '#FDD440' }} />
                                </div>
                                <div className="text" style={{ marginLeft: '10px' }}>
                                    <h2 style={{ margin: '10px 0' }}><b>{ApiData?.communityStats?.conversionRate || "0"}</b></h2>
                                    <h4>Conversion Rate</h4>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="col-sm-6 col-xs-12">
                    <div style={{ ...tabsStyle, display: 'flex' }}>
                        <div style={{ height: '130px', width: '130px', borderRadius: '50%' }}>
                            <AccountCircleIcon style={{ width: '100%', height: '100%', color: 'grey' }} />
                        </div>
                        <div style={{ marginLeft: '30px' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div>
                                    <h3>{ApiData?.communityName || "-"}</h3>
                                </div>
                                <div style={{ background: ApiData?.status == true ? '#579A1D' : "red", color: '#fff', padding: '6px 10px', borderRadius: '6px', marginLeft: '20px' }}>{ApiData?.status == true ? "Active" : "InActive"}</div>
                            </div>
                            <div>
                                <h5 style={{ fontSize: '16px' }}><b>Community Code :</b> <span style={{ color: '#0000005E' }}>{ApiData?.communityCode || "-"}</span></h5>
                                <h5 style={{ fontSize: '16px' }}><b>Region / Zone :</b> <span style={{ color: '#0000005E' }}>{ApiData?.communityCity + "/ " + ApiData?.communityState || "-"}</span></h5>
                            </div>
                        </div>
                    </div>

                    <div style={{ ...tabsStyle, marginTop: '30px' }}>
                        <h5 style={{ marginTop: '0' }}>Dealer wise engagement</h5>
                        <hr style={{ margin: '10px 0' }} />
                    </div>
                </div>
            </div>

            <div className="row" style={{ marginTop: '30px' }}>
                <div className="col-xs-12">
                    <div style={{...tabsStyle,height:'fit-content'}}>
                        <h5 style={{ marginTop: '0' }}><b>{tenant?.COMPANY_NAME} Agent</b></h5>
                        <div className='overflow-auto'>
                            <table className='phocket-table'>
                                <thead style={{ backgroundColor: '#223d64' }}>
                                    <tr>

                                        <th>Dealer</th>
                                        <th>Dealer Code</th>
                                        <th>Assigned</th>
                                        <th>Contacted</th>
                                        <th>Converted</th>

                                        <th>Conversion Rate</th>
                                        <th>Loan Disbursed</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        ApiData && ApiData?.communityDetailStats?.length > 0 ?
                                            ApiData?.communityDetailStats?.map((value, index) => {
                                                return (
                                                    <>
                                                        <tr>
                                                            <td>{value?.communityName || "-"}</td>
                                                            <td>{value?.communityCode || "-"}</td>
                                                            <td>{value?.communityStats?.assigned || "-"}</td>
                                                            <td>{value?.communityStats?.contacted || "-"}</td>
                                                            <td>{value?.communityStats?.converted || "-"}</td>
                                                            <td>{value?.communityStats?.conversionRate || "-"}</td>
                                                            <td>{value?.communityStats?.leadDisbursed || "-"}</td>

                                                        </tr>
                                                    </>
                                                )
                                            })
                                            : ''}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>


            <div className="row" style={{marginBottom:'20px'}}>
                <div className="col-sm-6 col-xs-12" style={{ marginTop: '30px' }}>
                    <div style={{ ...tabsStyle, height: '380px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h5 style={{ marginTop: '0', width: '100%' }}><b>Avg. TAT Trend</b></h5>
                            <select className='form-control' value={avgTatData} style={{width:'50%'}} onChange={(e)=>handleTat(e)}>
                                <option value={"week"}>Weeks</option>
                                <option value={"month"}>Months</option>
                                <option value={"year"}>Years</option>
                            </select>
                        </div>
                        <div style={{ height: '300px', marginTop: '15px' }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <AreaChart
                                    width={500}
                                    height={400}
                                    data={avgTatGraphData}
                                    margin={{
                                        top: 10,
                                        right: 10,
                                        left: -10,
                                        bottom: 0,
                                    }}
                                >
                                    <defs>
                                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                            <stop offset="5%" stopColor="#046582" stopOpacity={0.9} />
                                            <stop offset="95%" stopColor="#fff" stopOpacity={0} />
                                        </linearGradient>
                                    </defs>
                                    <CartesianGrid horizontal={true} vertical={false} />
                                    <XAxis dataKey="value" axisLine={false} />
                                    <YAxis axisLine={false} />
                                    <Tooltip />
                                    <Area type="monotone" dataKey="data" stroke="#046582" fill="url(#colorUv)" />
                                </AreaChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
                <div className="col-sm-6 col-xs-12" style={{ marginTop: '30px' }}>
                    <div style={{ ...tabsStyle, height: '380px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h5 style={{ marginTop: '0', width: '100%' }}><b>Lead Ageing Report</b></h5>
                            <select className='form-control' value={ageingData} style={{width:'50%'}} onChange={(e)=>handleAgeing(e)}>
                                <option value={"week"}>Weeks</option>
                                <option value={"month"}>Months</option>
                                <option value={"year"}>Years</option>
                            </select>
                        </div>
                        <div style={{ height: '300px', marginTop: '15px' }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart width={150} height={40} data={agentPerformance}
                                    barSize={30}
                                    margin={{
                                        top: 10,
                                        right: 10,
                                        left: -10,
                                        bottom: 0,
                                    }}>
                                    <CartesianGrid horizontal={true} vertical={false} />
                                    <XAxis dataKey="value" axisLine={false} />
                                    <YAxis axisLine={false} />
                                    <Tooltip />
                                    <Bar dataKey="data" fill="#FF8158" radius={[5, 5, 5, 5]} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
                <div className=" col-xs-12" style={{ marginTop: '30px' }}>
                    <div style={{ ...tabsStyle, height: '380px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h5 style={{ marginTop: '0', width: '100%' }}><b>Dealer wise Agent Performance</b></h5>
                            <select className='form-control' value={agentPerformanceData} style={{width:'20%'}} onChange={(e)=>handleAgentPerformance(e)}>
                                <option value={"assigned"}>Assigned</option>
                                <option value={"contacted"}>Contacted</option>
                                <option value={"converted"}>Converted</option>
                            </select>
                        </div>
                        <div style={{ height: '300px', marginTop: '15px' }}>
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart width={150} height={40} data={dealerAgentPerformance}
                                    barSize={30}
                                    margin={{
                                        top: 10,
                                        right: 10,
                                        left: -10,
                                        bottom: 0,
                                    }}>
                                    <CartesianGrid horizontal={true} vertical={false} />
                                    <XAxis dataKey="name" axisLine={false} />
                                    <YAxis axisLine={false} />
                                    <Tooltip />
                                    <Bar dataKey="value" fill="#6FA6B5" radius={[5, 5, 5, 5]} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}


const tabsStyle = {
    marginTop: '10px',
    background: '#fff',
    padding: '20px',
    borderRadius: '6px',
    boxShadow: '3px 3px 10px 1px #eee',
    height: '185px'
}

const circleStyle = {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    padding: "17px 15px",
    textAlign: 'center'
}